module.exports = ".table {\n  font-size: 0.8em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-committee.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-committee.component.scss
// module chunks = main